import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { setHasNoData, setIsSearchDisabled } from "../Directory/directorySlice";

export const fetchSOLData = createAsyncThunk(
  "sols/fetchSOLData",
  async ({ url, config }, { dispatch }) => {
    try {
      const response = await axios.get(url, config);
      const data = response.data.data;

      // Dispatch setHasNoData based on whether the data is empty or not
      if (!data || data.length === 0) {
        dispatch(setHasNoData(true)); // Set hasNoData to true if data is empty
      } else {
        dispatch(setHasNoData(false)); // Set hasNoData to false if data exists
        dispatch(setIsSearchDisabled(false));
      }

      return data;
    } catch (error) {
      throw new Error(error.response?.data?.message || "Failed to fetch data");
    }
  }
);

const initialState = {
  sols: [],
  status: "idle",
  loading: true,
  error: null,
};

const solTemplatesSlice = createSlice({
  name: "solTemplates",
  initialState,
  reducers: {
    addSOL: (state, action) => {
      state.sols.push(action.payload);
    },

    updateSOL: (state, action) => {
      const { id, updatedData } = action.payload;
      const index = state.sols.findIndex((sol) => sol.id === id);
      if (index !== -1) {
        state.sols[index] = { ...updatedData };
      }
    },

    deleteSOL: (state, action) => {
      const id = action.payload;
      state.sols = state.sols.filter((sol) => sol.id !== id);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSOLData.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(fetchSOLData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.sols = action.payload;
        state.loading = false;
      })
      .addCase(fetchSOLData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { addSOL, updateSOL, deleteSOL } = solTemplatesSlice.actions;

export default solTemplatesSlice.reducer;
